module.exports = __webpack_public_path__ + "img/server.323e021b.svg";